import { cn } from '@/shared/lib/cn';
import { DISCIPLINE_LABELS, type Discipline } from '../model/labels';

const disciplineColors: Record<Discipline, string> = {
  tennis: 'var(--color-discipline-tennis)',
  padel: 'var(--color-discipline-padel)',
  squash: 'var(--color-discipline-squash)',
  pickleball: 'var(--color-discipline-pickleball)',
};

export interface SportIconProps {
  discipline: Discipline;
  /** Wypelnia znak kolorem dyscypliny zamiast rysowac sam kontur. */
  filled?: boolean;
  className?: string;
}

/**
 * Znak dyscypliny — uproszczona rakieta z naciagiem, wzorowana na znaku z logo.
 *
 * Rysowany w SVG, wiec jest ostry w kazdym rozmiarze i przyjmuje kolor
 * dyscypliny z brandbooka.
 */
export function SportIcon({ discipline, filled = false, className }: SportIconProps) {
  const color = disciplineColors[discipline];

  return (
    <svg
      viewBox="0 0 24 24"
      role="img"
      aria-label={DISCIPLINE_LABELS[discipline]}
      className={cn('size-5 shrink-0', className)}
    >
      <rect
        x="2.5"
        y="2.5"
        width="19"
        height="19"
        rx="6"
        fill={filled ? color : 'none'}
        stroke={filled ? 'var(--color-fg-strong)' : color}
        strokeWidth="1.6"
      />
      <path
        d="M4 12c4 0 6-3 8-3s4 3 8 3"
        fill="none"
        stroke={filled ? 'var(--color-fg-strong)' : color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M4 12c4 0 6 3 8 3s4-3 8-3"
        fill="none"
        stroke={filled ? 'var(--color-fg-strong)' : color}
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <circle cx="16.5" cy="12" r="1" fill={filled ? 'var(--color-fg-strong)' : color} />
    </svg>
  );
}

export interface CourtIconProps {
  className?: string;
  label?: string;
}

/** Znak kortu — prostokat z siatka i liniami, jak przy nazwach kortow w makietach. */
export function CourtIcon({ className, label = 'Kort' }: CourtIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      role="img"
      aria-label={label}
      className={cn('size-5 shrink-0', className)}
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4.5" width="18" height="15" rx="2" />
      <path d="M12 4.5v15" />
      <path d="M3 9.5h4.5v5H3M21 9.5h-4.5v5H21" />
    </svg>
  );
}
